<mad-material-action-button
  [actionName]="'Add something'"
  [icon]="'add'"
  [liftHigher]="false"
  [routerLink]="'/action-button'"
  [id]="'add'"
  class="action-button-wo-position"
>
</mad-material-action-button>
